export enum SearchFormField {
  TOWN_TO_FORM_FIELD = 'town-to-from-field',
  ARRIVAL_FORM_FIELD = 'arrival-form-field',
  DATE_FORM_FIELD = 'date-form-field',
  PASSENGERS_COUNT_FORM_FIELD = 'passengers_count_form_field',
}
